import Vue from 'vue'
import App from './App'
import Axios from 'axios'
import router from '@/router'
import store from '@/store'
// 引入swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
// 引入iscroll
// import IScroll from 'iscroll'
// 引入全局组件
import modal from './components/modal.vue'
// 引入事件格式处理插件
import Moment from 'moment'

import directives from './directives'

// 定义全局指令
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key])
})

Vue.prototype.$ajax = Axios
// 配置默认的请求url
// Axios.defaults.baseURL = 'http://ego.geekbang.org/api/'

Vue.config.productionTip = false

Vue.use(VueAwesomeSwiper)

// 声明全局组件
Vue.component('modal', modal)

// 声明全局过滤器
Vue.filter('formatDate', function (value) {
  return Moment(value).format('YYYY-MM-DD')
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
